import { render, staticRenderFns } from "./swiper-collapse.vue?vue&type=template&id=7e04e990&scoped=true&"
import script from "./swiper-collapse.vue?vue&type=script&lang=js&"
export * from "./swiper-collapse.vue?vue&type=script&lang=js&"
import style0 from "./swiper-collapse.vue?vue&type=style&index=0&id=7e04e990&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e04e990",
  null
  
)

export default component.exports